import React from "react";
import i18n from "../../../../utils/ChrI18n";
import ChrLink from "../../../generic/Utils/ChrLink";
import ModalAndTooltip from "../../../../interfaces/ModalAndTooltip";

const CreateAlert = (props) => {
  const {
    newAlertPath,
    label = i18n.t("display_string.Add"),
    iconClass = "fa fa-plus",
    onTrigger = () => {}
  } = props;

  const onCreate = () => {
    onTrigger();
    newAlertPath && ModalAndTooltip.showManagementReportModal(newAlertPath);
  }

  return (
    <ChrLink noHref className="text-info" onClick={onCreate}>
      <i className={`${iconClass} m-r-xs`} />
      <span>{label}</span>
    </ChrLink>
  );
}

export default CreateAlert;
